
import React from 'react';
import { Instagram, Link as LinkIcon } from 'lucide-react';

const SocialLinks = () => {
  return (
    <section className="mb-16">
      <h2 className="section-title-left mb-6">Connect With Us</h2>
      <div className="flex flex-col md:flex-row md:space-x-8">
        <a 
          href="https://www.instagram.com/catsabouttowntours/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center hover:text-accent transition-colors mb-4 md:mb-0"
        >
          <Instagram size={20} className="mr-2" />
          <span>@catsabouttowntours</span>
        </a>
        
        <a 
          href="https://fareharbor.com/embeds/book/catsabouttown/items/562633/calendar/?flow=1219724&full-items=yes" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center hover:text-accent transition-colors mb-4 md:mb-0"
        >
          <LinkIcon size={20} className="mr-2" />
          <span>Purchase Gift Cards</span>
        </a>
        
        <a 
          href="https://docs.google.com/forms/d/e/1FAIpQLSfASSkWgxnnQPnmqZ4vKvDGcAZ9V_O4k5tXK9EPg0o9PI8K9Q/viewform" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center hover:text-accent transition-colors"
        >
          <LinkIcon size={20} className="mr-2" />
          <span>Jerry Fox Petition</span>
        </a>
      </div>
    </section>
  );
};

export default SocialLinks;
